import API from '@/modules/exam-report/api';
import { analyzeGradeMap, analyzeSubjectMap } from '@/scripts/analyzeMap';
import { isEmptyArray, isArray } from '@/scripts/validate';
import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';
import serve from '@/scripts/serve'

let timeId = null;

/**
 * vuex 的成绩报表模块
 * 为了简化操作，直接在 mutations 里修改 state 的值了
 *
 */
export default {
  namespaced: true,
  state: () => ({
    exam: {}, // 考试信息
    examInfo: {}, // 兼容 examInfo 用法

    districts: [], // tree结构 行政区域 目前只有地级和乡镇
    cityOptions: [],
    districtOptions: [],
    schoolAndClasses: [], // tree结构 学校和班级
    schoolOptions: [],
    classesOptions: [],
    levelProgress: 0,
    teacherVisiable: true, // 排名对老师是否可见
    studentVisiable: false, // 排名对学生是否可见
    highSubjectList: [], // 高中报表目列表
    haveTotalScore: false // 科目列表是否有总分
  }),
  getters: {
    examId: state => (state.exam.id || ''),
    examName: state => (state.exam.name || ''),
    gradeId: state => (state.exam.grade_id || ''),
    examInfo: state => state.examInfo || state.exam,
    isHighStage: (state, getters) => getters.gradeId >= 10,
    gradeStage: (state, getters) => {
      const { gradeId } = getters;
      if (!gradeId) return '';
      return analyzeGradeMap[gradeId].stage;
    },
    gradeName: (state, getters) => {
      const { gradeId } = getters;
      if (!gradeId) return '';
      return analyzeGradeMap[gradeId].name;
    },
    subjectIds: state => (state.exam
      ? state.exam.subject_ids || (state.exam.subject_id && [state.exam.subject_id]) || []
      : []),

    subjectOptions: (state, getters, rootState, rootGetters) => {
      // 当前考试的科目
      let { subjectIds } = getters;
      const permissionSubjectList = rootGetters['user/permissionSubjectList'];

      // 检查是否为巡考员切换身份到教研员
      const examinationUserAccount = localStorage.getItem('examination_user_account');
      const isInspectorAsTeacher = !!examinationUserAccount;
      const currentRole = rootState.user.permission?.role;

      console.log('subjectOptions 科目过滤检查:', {
        isInspectorAsTeacher,
        currentRole,
        examinationUserAccount,
        originalSubjectIds: subjectIds
      });

      let res = [];
      if (isArray(subjectIds)) {
        // 首先应用原有的权限过滤
        if (permissionSubjectList.length) {
          subjectIds = subjectIds.filter(e => permissionSubjectList.find(u => u.id == e));
          console.log('应用原有权限过滤后:', subjectIds);
        }

        // 如果是巡考员切换身份到教研员，应用额外的科目权限过滤
        if (isInspectorAsTeacher && currentRole === '教研员') {
          console.log('检测到巡考员切换身份到教研员，应用科目权限过滤');

          // 获取当前考试ID
          const currentExamId = localStorage.getItem('current_exam_id');
          console.log('当前考试ID:', currentExamId);

          // 从localStorage获取教研员的科目权限
          const teacherSubjectPermissionsStr = localStorage.getItem('teacher_subject_permissions');
          if (teacherSubjectPermissionsStr) {
            try {
              const teacherSubjectPermissions = JSON.parse(teacherSubjectPermissionsStr);
              console.log('从localStorage获取的教研员科目权限:', teacherSubjectPermissions);

              // 过滤科目，只保留教研员有权限的科目
              const originalCount = subjectIds.length;
              subjectIds = subjectIds.filter(subjectId => teacherSubjectPermissions.includes(subjectId));
              console.log(`教研员科目权限过滤: ${originalCount} → ${subjectIds.length}`);
            } catch (error) {
              console.error('解析教研员科目权限失败:', error);
              subjectIds = [];
            }
          } else {
            console.log('未找到教研员科目权限，返回空数组');
            subjectIds = [];
          }
        }

        res = subjectIds.map(id => {
          let subjectLabel = analyzeSubjectMap[id]
          if (state.exam && state.exam.grade_id && state.exam.grade_id <= 9 && id === 7) {
            subjectLabel = '道德与法治'
          }
          if (state.exam && state.exam.grade_id && state.exam.grade_id >= 10 && id === 7) {
            subjectLabel = '思想政治'
          }
          return {
            value: id,
            label: subjectLabel,
          };
        });
      }

      console.log('最终科目选项:', res);
      return res;
    },

    // 高中报表**单科**科目列表
    // highSubjectList: (state, getters, rootState, rootGetters) => {
    //   const permissionSubjectList = rootGetters['user/permissionSubjectList'];
    //   let list = [];
    //   for (const [, v] of Object.entries(highExamSubject)) {
    //     list = list.concat(v);
    //   }
    //   if (permissionSubjectList.length) {
    //     list = list.filter(e => permissionSubjectList.find(u => u.id === e.id));
    //   }
    //   return list;
    // },
  },
  mutations: {
    CLEAR_SCHOOL_AND_CLASSES(state) {
      state.schoolAndClasses = [];
    },
    GET_CITY_OPTIONS(state) {
      const { districts } = state;
      let list = [];
      if (isArray(districts)) {
        list = districts.map(({
          F_id, F_level, F_name, F_pid
        }) => ({
          F_id, F_level, F_name, F_pid
        }));
      }
      state.cityOptions = list;
    },

    // 根据城市id获取镇区选项列表
    GET_DISTRICT_OPTIONS(state, payload) {
      const match = state.districts.find(_ => _.F_id === payload.cityId);
      state.districtOptions = match.children;
    },

    getSchoolOptions(state, payload) {
      let { districtId } = payload;
      let list = [];
      if (!districtId || isEmptyArray(districtId)) {
        list = JSON.parse(JSON.stringify(state.schoolAndClasses));
      } else {
        districtId = isArray(districtId) ? districtId : [districtId];
        list = state.schoolAndClasses.filter(e => districtId.indexOf(e.district_id) > -1);
      }
      state.schoolOptions = list;
    },

    cancelGetProgress() {
      clearInterval(timeId);
      timeId = null;
    },
    // changeRankingVisiable(state, payload) {
    //   state.teacherVisiable = Boolean(payload.is_show_rank_to_teacher);
    //   state.studentVisiable = Boolean(payload.is_show_rank_to_student);
    // }

  },
  actions: {
    changeRankingVisiable({ state, rootState }, payload) {
      const { user: { permission: { role, school_id } } } = rootState;
      if (school_id == 1000697) {
        const roleList = ['校长', '校务管理员'];
        const value = payload.is_show_rank_to_teacher && roleList.includes(role);
        state.teacherVisiable = Boolean(value);
      } else {
        state.teacherVisiable = Boolean(payload.is_show_rank_to_teacher);
      }
      state.studentVisiable = Boolean(payload.is_show_rank_to_student);
    },
    /** 获取这场考试的全部信息 */
    async GET_EXAM_INFO({ state }, payload) {
      const res = await API.exam.getExamInfo(payload);
      state.exam = res;
      state.examInfo = res;
    },

    // 获取考试区域信息
    async GET_DISTRICTS({ state, commit }, payload) {
      const { examId, countyList } = payload;
      const list = await API.examReport.getDistricts(examId);
      if (countyList) {
        const group = groupBy(countyList, 'F_pid');
        Object.entries(group).forEach(([cityId, countyList]) => {
          cityId = Number(cityId);
          const countyIds = countyList.map(_ => _.F_id);
          const index = list.findIndex(_ => _.F_id === cityId);
          if (index > -1) {
            list[index].children = list[index].children.filter(
              _ => countyIds.indexOf(_.F_id) > -1
            );
          }
        });
      }
      state.districts = list;
      commit('GET_CITY_OPTIONS');
    },

    async getSchoolAndClasses({ state }, payload) {
      const res = await API.examReport.getSchoolAndClasses(payload);
      // 先将学校按学校id排序
      res.sort((a, b) => a.school_id - b.school_id);
      // 再按districtIds的镇区顺序排序
      const districtIds = state.districtOptions.map(e => e.F_id);
      res.sort((a, b) => districtIds.indexOf(a.district_id) - districtIds.indexOf(b.district_id));
      // 班级按照名字排序
      // res.forEach((_) => {
      //   _.classes.forEach((item) => {
      //     let classNum = item.class_name.replace(/[^0-9]/gi, '');
      //     item.classNum = Number(classNum);
      //   });
      //   _.classes = orderBy(_.classes, 'classNum', ['asc']);
      // });
      state.schoolAndClasses = res;
    },

    getClassesOptions({ state, rootState }, payload) {
      let { schoolId, needGroupBy } = payload;
      let list = [];
      if (!schoolId || isEmptyArray(schoolId)) {
        list = JSON.parse(JSON.stringify(state.schoolAndClasses));
      } else {
        schoolId = isArray(schoolId) ? schoolId : [schoolId];
        list = state.schoolAndClasses.filter(_ => schoolId.indexOf(_.school_id) > -1);

        // 只考虑单校的时候，读取该账号的 class_list，有的话取交集
        const { user: { permission: { permission: { class_list } } } } = rootState;
        if (schoolId.length === 1 && class_list.length) {
          const ids = class_list.map(e => e.F_id);
          list[0].classes = list[0].classes.filter(e => ids.includes(e.class_id))
        }
      }
      // classesOptions为多个校的班级列表,以校分,如果是学校教师或者学校筛选是单选,则取第一项(也只有一项)的班级列表
      list = needGroupBy ? list : list[0].classes;
      state.classesOptions = list;
    },

    async getLevelProgress({ state, commit }) {
      const { status_code, data } = await API.examReport.getJobProgress({
        mark: `update_rank_score:${state.examId}`,
      });
      // 没有正在进行的计算任务
      if (status_code !== 200) {
        state.levelProgress = 100;
        if (timeId !== null) {
          commit('cancelGetProgress')
        }
      } else {
        // 有正在进行的计算任务
        state.levelProgress = data.progress;
        if (timeId === null) {
          commit('intervalGetProgress')
        }
      }
    },

    intervalGetProgress({ dispatch }) {
      timeId = setInterval(() => {
        dispatch('getLevelProgress')
      }, 5000);
    },

    // 获取高中报表**单科**科目列表
    async getHighSubjectList({ state, rootGetters, rootState }, payload) {
      const permissionSubjectList = rootGetters['user/permissionSubjectList'];
      const res = await serve.getExamSubject({ exam_id: payload.examId, is_include_total_score: 1 });
      console.log('getHighSubjectList res:', res);
      const data = res.body?.data || [];
      state.haveTotalScore = data.includes(3000);
      let list = [];
      (data || []).map(id => {
        const item = analyzeSubjectMap[id];
        if (item) {
          list.push({ id, name: item })
        }
      });

      // 检查是否为巡考员切换身份到教研员
      const examinationUserAccount = localStorage.getItem('examination_user_account');
      const isInspectorAsTeacher = !!examinationUserAccount;
      const currentRole = rootState.user.permission?.role;

      console.log('getHighSubjectList 教研员科目权限检查:', {
        isInspectorAsTeacher,
        currentRole,
        examinationUserAccount,
        originalList: list
      });

      // 首先应用原有的权限过滤
      if (permissionSubjectList.length) {
        list = list.filter(e => permissionSubjectList.find(u => u.id === e.id));
        console.log('应用原有权限过滤后:', list);
      }

      // 如果是巡考员切换身份到教研员，应用额外的科目权限过滤
      if (isInspectorAsTeacher && currentRole === '教研员') {
        console.log('检测到巡考员切换身份到教研员，应用科目权限过滤');

        // 获取当前考试ID
        const currentExamId = localStorage.getItem('current_exam_id');
        if (!currentExamId) {
          console.log('⚠️ 未找到当前考试ID，返回空科目列表');
          list = [];
          state.highSubjectList = list;
          return;
        }

        // 解析教研员科目ID的工具函数
        const parseTeacherSubjectIds = subjectIdStr => {
          console.log('parseTeacherSubjectIds 输入:', subjectIdStr, '类型:', typeof subjectIdStr);

          if (!subjectIdStr) {
            console.log('subjectIdStr 为空，返回空数组');
            return [];
          }

          if (typeof subjectIdStr === 'string') {
            // 处理 "1,2,3" 格式或单个 "1" 格式
            const ids = subjectIdStr.split(',').map(id => parseInt(id.trim(), 10)).filter(id => !isNaN(id));
            console.log('字符串解析结果:', ids);
            return ids;
          } if (Array.isArray(subjectIdStr)) {
            // 处理数组格式
            const ids = subjectIdStr.map(id => parseInt(id, 10)).filter(id => !isNaN(id));
            console.log('数组解析结果:', ids);
            return ids;
          } if (typeof subjectIdStr === 'number') {
            // 处理单个数字
            console.log('数字解析结果:', [subjectIdStr]);
            return [subjectIdStr];
          }

          console.log('未知格式，返回空数组');
          return [];
        };

        try {
          // 调用接口获取教研员的科目权限
          const teacherResponse = await serve.getInspectorExams(examinationUserAccount);
          console.log('教研员权限接口响应:', teacherResponse.body);

          if (teacherResponse.status === 200 && teacherResponse.body) {
            const teacherData = teacherResponse.body;
            console.log('teacherData:', teacherData);

            // 按考试ID过滤权限数据
            console.log('按考试ID过滤权限，当前考试ID:', currentExamId);
            let currentExamData = [];

            if (Array.isArray(teacherData)) {
              currentExamData = teacherData.filter(item => item.exam_id && item.exam_id.toString() === currentExamId.toString());
            } else if (teacherData.exam_id && teacherData.exam_id.toString() === currentExamId.toString()) {
              currentExamData = [teacherData];
            }

            console.log('当前考试的权限数据:', currentExamData);

            if (currentExamData.length === 0) {
              console.log('⚠️ 未找到当前考试的权限数据');
              list = [];
              state.highSubjectList = list;
              return;
            }

            // 解析subject_id，支持多种格式
            let teacherSubjectIds = [];
            currentExamData.forEach((item, index) => {
              console.log(`处理当前考试第${index + 1}个元素:`, item);
              if (item.subject_id) {
                // 使用parseTeacherSubjectIds函数解析subject_id
                const parsedIds = parseTeacherSubjectIds(item.subject_id);
                console.log(`当前考试第${index + 1}个元素的subject_id: ${item.subject_id}, 解析结果:`, parsedIds);
                teacherSubjectIds.push(...parsedIds);
              }
            });

            // 去重
            teacherSubjectIds = [...new Set(teacherSubjectIds)];
            console.log('去重后的teacherSubjectIds:', teacherSubjectIds);

            // 过滤科目，只保留教研员有权限的科目
            const originalCount = list.length;
            list = list.filter(subject => teacherSubjectIds.includes(subject.id));
            console.log(`教研员科目权限过滤: ${originalCount} → ${list.length}`);

            // 将教研员的科目权限存储到localStorage中，供其他地方使用
            if (teacherSubjectIds.length > 0) {
              localStorage.setItem('teacher_subject_permissions', JSON.stringify(teacherSubjectIds));
              console.log('已存储教研员科目权限到localStorage:', teacherSubjectIds);
            }
          } else {
            console.log('教研员权限接口响应不符合预期');
            list = [];
          }
        } catch (error) {
          console.error('获取教研员科目权限失败:', error);
          list = [];
        }
      }

      console.log('getHighSubjectList final list:', list);
      state.highSubjectList = list;
    }
  },
}
